module.exports = __webpack_public_path__ + "0470afed4e06119d71d8bb22a6e74aef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/owlidays-cup.png
// module id = 2079
// module chunks = 0